import type { Status } from '@/types'
import { get } from '@/util/auth'

import { API_ROUTE_DASHBOARD_STATUS } from '../../resources/api-routes'

const IS_NEW_BACKEND_API = true

const dashboardResources = {
  get: (): Promise<Status> => get(API_ROUTE_DASHBOARD_STATUS, IS_NEW_BACKEND_API),
}

export default dashboardResources
